module.exports = __webpack_public_path__ + "media/images/gallery/constellations/capricornus/cap_vis-b2e9297beaa721cebc07612ccd605c68.jpg";